export const tableV2HeaderHeight = '38px';
export const tableV2FooterHeight = '44px';
export const tableV2FooterControlHeightPx = 34;
export const tableV2MinimumVisibleRows = 10;
export const tableV2BodyRowHeightPx = 65;
export const tableV2NestedHeaderHeight = '38px';
export const tableV2NestedBodyRowHeightPx = tableV2BodyRowHeightPx;
export const tableV2ChevronColumnWidth = '48px';
export const tableV2ChevronIconSize = '22px';
export const tableV2ChevronOffsetTransform = 'translate(calc(-50% - 2px), calc(-50% - 2px))';
export const tableV2SkeletonChevronOffsetTransform =
  'translate(calc(-50% + 2px), calc(-50% + 2px))';
export const tableV2ActionsColumnWidth = '44px';
export const tableV2NamePrimaryFontSize = '13px';
